import jwtDecode from 'jwt-decode';

import { resetRegister, updateEmail, updatePassword } from '../../redux/actions/userActions';
import { FIND_IS_AUTHENTICATED, FIND_TOKEN_DECODE, FIND_TOKEN } from '../../redux/types';

/**
 * Factory function for authentication.
 * Returns an asynchronous function that performs the login and returns success or error.
 * @param {object} dispatch - Redux dispatch function.
 * @param {object} authService - Instance of AuthService.
 * @returns {function(payload): Promise<{ success: boolean, data?: object, error?: any }>}
 */
export const handleAccessFactory = (dispatch, authService, currentStep) => async (payload) => {
  try {
    const response = await authService.signIn(payload);

    const decoded = jwtDecode(response.data.token);

    const { email } = decoded.user;

    if (email) {
      dispatch(updateEmail(email));
      const requestData = JSON.parse(response.config.data);
      const { password } = requestData;
      dispatch(updatePassword(password, password));
    }

    if (currentStep === 5 && response.status === 200) {
      dispatch({ type: FIND_TOKEN, token: response.data.token });
      dispatch({ type: FIND_TOKEN_DECODE, decodeToken: decoded });
      dispatch({ type: FIND_IS_AUTHENTICATED, isAuthenticated: true });
      dispatch(resetRegister());
    }

    return {
      success: true,
      data: { token: response.data.token, decoded },
    };
  } catch (error) {
    return { success: false, error };
  }
};
